export default __webpack_public_path__ + "static/media/sample_attendee.39f0909b.xlsx";